import React from 'react';

import { Tooltip } from '@trqk/components';
import { formatDollarsStatement } from '@trqk/utils';
import { DataCardRow } from './components';
import { PerformancesTableButton } from '../../../../nav';

const earningsColor = 'quarternary';

interface TopWritersOrPublishersRowProps {
    datum: InsightComposerSummaryData | InsightPublisherSummaryData;
    index: number;
    statementIdEnd: Maybe<string>;
    statementIdStart: Maybe<string>;
    urlParamKey: string;
}

export const TopWritersOrPublishersRow = ({
    datum,
    index,
    statementIdEnd,
    statementIdStart,
    urlParamKey,
}: TopWritersOrPublishersRowProps): JSX.Element => {
    const { earnings, name } = datum;

    const buttonContent = (
        <div className="grid">
            <div className="font-medium underline truncate">{name}</div>
        </div>
    );

    const hasStatementRange =
        statementIdEnd !== null || statementIdStart !== null;

    return (
        <DataCardRow index={index}>
            <Tooltip message={name} position="bottom" background="light">
                {hasStatementRange && (
                    <PerformancesTableButton
                        urlSearchParams={[{ key: urlParamKey, value: name }]}
                        statementSelectionLogic={{
                            type: 'statementRange',
                            statementRange: {
                                statementIdEnd: statementIdEnd ?? undefined,
                                statementIdStart: statementIdStart ?? undefined,
                            },
                        }}
                    >
                        {buttonContent}
                    </PerformancesTableButton>
                )}
                {!hasStatementRange && (
                    <PerformancesTableButton
                        urlSearchParams={[{ key: urlParamKey, value: name }]}
                        statementSelectionLogic={{
                            type: 'presetsWithRegion',
                            presetsWithRegion: {
                                primary: 'all_domestic',
                                fallback: 'all_international',
                            },
                        }}
                    >
                        {buttonContent}
                    </PerformancesTableButton>
                )}
            </Tooltip>
            <span className={`ml-2 font-semibold text-${earningsColor}-500`}>
                {formatDollarsStatement(earnings)}
            </span>
        </DataCardRow>
    );
};
